import React from 'react';
import styled from 'styled-components'
const StatBlockWrapper = styled.div`
    .stat-block-grid {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .stat-block {
        width: 20%;
    }
    span.stat-title {
        display: block;
    }
    span.stat-data {
        display: block;
        font-size: 3rem;
    }
    @media all and (max-width: 1024px) {
        .stat-block {
            width: 33.333%;
            margin-bottom: 2rem;
        }
        span.stat-data {
            display: block;
            font-size: 2.666rem;
        }
    }
    @media all and (max-width: 767px) {
        .stat-block {
            width: 50%;
        }
        span.stat-data {
            display: block;
            font-size: 2.666rem;
        }
    }
     @media all and (max-width: 767px) {
        .stat-block {
            width: 100%;
        }
        span.stat-data {
            display: block;
            font-size: 2rem;
        }
    }
`
const StatsBlocks = ({stats}) => {
  return (
      <StatBlockWrapper className="row-component">
          <div className="contain">
              <div className="stat-block-grid">
                {stats.map((stat) =>{
                    return (
                        <div className="stat-block">
                            <span className="stat-title">
                                    {stat.statTitle}
                            </span>
                            <span className="stat-data">
                                    {stat.stat}
                            </span>
                        </div>
                    )
                })}
            </div>
          </div>
      </StatBlockWrapper>
  );
};

export default StatsBlocks;
